import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { rootRoute } from '../../router/routes/rootRoute';

export const searchLoginSchema = z
	.object({
		hasInvalidRoles: z.boolean().optional(),
	})
	.prefault({});

export type SearchLoginType = z.infer<typeof searchLoginSchema>;

export const loginRoute = createRoute({
	path: '/login',
	getParentRoute: () => rootRoute,
	component: lazyRouteComponent(() => import('./LoginPage'), 'LoginPage'),
	staticData: {
		disableAuthGuard: true,
	},
	validateSearch: searchLoginSchema,
});
